var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2857 5.14286C10.2857 7.98318 7.98318 10.2857 5.14286 10.2857C2.30254 10.2857 0 7.98318 0 5.14286C0 2.30254 2.30254 0 5.14286 0C7.98318 0 10.2857 2.30254 10.2857 5.14286ZM5.71429 2.85714C5.71429 2.54155 5.45845 2.28571 5.14286 2.28571C4.82727 2.28571 4.57143 2.54155 4.57143 2.85714V4.57143H2.85714C2.54155 4.57143 2.28571 4.82727 2.28571 5.14286C2.28571 5.45845 2.54155 5.71429 2.85714 5.71429H4.57143V7.42857C4.57143 7.74416 4.82727 8 5.14286 8C5.45845 8 5.71429 7.74416 5.71429 7.42857V5.71429H7.42857C7.74416 5.71429 8 5.45845 8 5.14286C8 4.82727 7.74416 4.57143 7.42857 4.57143H5.71429V2.85714Z",
    fill: "#659DBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1428 3.4285H11.192C11.0793 3.03006 10.9282 2.64769 10.7432 2.28564H13.1428C14.7208 2.28564 16 3.56483 16 5.14279V10.0408C16 10.4955 15.8194 10.9315 15.4979 11.253L11.253 15.4979C10.9315 15.8194 10.4955 15.9999 10.0409 15.9999H5.14285C3.56489 15.9999 2.28571 14.7207 2.28571 13.1428V10.7431C2.64775 10.9282 3.03012 11.0792 3.42856 11.1919V13.1428C3.42856 14.0895 4.19607 14.8571 5.14285 14.8571H9.14285V12.5714C9.14285 10.6778 10.6778 9.14279 12.5714 9.14279H14.8571V5.14279C14.8571 4.19601 14.0896 3.4285 13.1428 3.4285ZM10.2857 14.802C10.3442 14.7742 10.3983 14.7364 10.4449 14.6898L14.6898 10.4448C14.7364 10.3982 14.7743 10.3442 14.802 10.2856H12.5714C11.309 10.2856 10.2857 11.309 10.2857 12.5714V14.802Z",
    fill: "#659DBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNote);
export default __webpack_public_path__ + "static/media/addNote.3a47a3859cdd38669cc214cbf5612fe4.svg";
export { ForwardRef as ReactComponent };